import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import Accordion from 'src/components/basicContent/_Accordion/Accordion';

import ChevronDownIcon from 'public/icons/ChevronDown.svg';

import { ForgotPasswordRichText } from './_ForgotPasswordRichText';

import styles from './_ForgotPassword.module.css';

type ForgotPasswordProps = {
	headerText?: Field<string>;
	bodyText?: Field<string>;
	targetHash: string;
	modalState?: boolean;
	clickHandler: () => void;
};

export function ForgotPassword(props: ForgotPasswordProps): JSX.Element {
	return (
		<Accordion
			headerClass={`${styles.resetPasswordAccordionHeader} link linkOffset linkHoverWeighted`}
			bodyClass={styles.resetPasswordAccordionBody}
			sectionClass={styles.resetPasswordAccordion}
			ancestorState={props.modalState}
		>
			<span className={styles.resetPasswordAccordionHeaderContent}>
				<Text field={props.headerText} />

				<ChevronDownIcon className={styles.resetPasswordAccordionIcon} />
			</span>

			<ForgotPasswordRichText
				className={`${styles.small} ${styles.forgotPasswordText}`}
				richText={props.bodyText?.value}
				targetHash={props.targetHash}
				clickHandler={props.clickHandler}
			/>
		</Accordion>
	);
}
